export default __webpack_public_path__ + "static/ERP-01 2-40bf8dab623f5387c84adeb969d118d4.png";